import { animate, state, style, transition, trigger } from '@angular/animations';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { ConfirmationDialogComponent } from 'src/app/common/ConfirmationDialog/confirmation-dialog/confirmation-dialog.component';
import { Constant } from 'src/app/common/constant';
import { SelectPreferenceComponent } from 'src/app/common/select-preference-dialog/select-preference/select-preference.component';
import { DialogDataModel } from 'src/app/common/select-preference-dialog/selection-preference-data-model/dialog-data-model';
import { InventoryType } from 'src/app/model/FacilityManager/inventory-type';
import { ProductGroup } from 'src/app/model/Master/Group/product-group';
import { Location } from 'src/app/model/Master/Location/location';
import { ProductMatrix } from 'src/app/model/Master/Matrix/product-matrix';
import { ProductDetail } from 'src/app/model/Master/Product/product-detail';
import { ProductSubGroup } from 'src/app/model/Master/Sub Group/product-sub-group';
import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';
import { ProductCosting } from 'src/app/model/Production/Costing/product-costing';
import { MastercontainerService } from 'src/app/service/Master/mastercontainer.service';
import { ProductionService } from 'src/app/service/Production/production.service';
import { ToastService } from 'src/app/service/toast.service';


@Component({
  selector: 'app-production-costing',
  templateUrl: './production-costing.component.html',
  styleUrls: ['./production-costing.component.css'],

  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class ProductionCostingComponent implements OnInit, OnDestroy {

  productionSetUpForm: UntypedFormGroup;
  viewSetUpForm: UntypedFormGroup;
  deleteSetUpForm: UntypedFormGroup;
  myControlConvUnit: UntypedFormControl = new UntypedFormControl();

  productSearch: ProductDetail[] = [];
  filteredOptions: Observable<ProductDetail[]>;
  myControl = new UntypedFormControl();

  //Variables
  unitList: string[] = [];
  // productDetailSearch: ProductDetail[] = [];
  // filteredOptionsDetail: Observable<ProductDetail[]>;
  // myControl1 = new FormControl();

  rawMaterialSearch: ProductDetail[] = [];
  filteredOptionsRawMaterial: Observable<ProductDetail[]>;
  myControlRawMaterial = new UntypedFormControl();

  finishedMaterialSearch: ProductDetail[] = [];
  filteredOptionsFinishedMaterial: Observable<ProductDetail[]>;
  myControlFinishedMaterial = new UntypedFormControl();

  semiFinishedMaterialSearch: ProductDetail[] = [];
  filteredOptionsSemiFinishedMaterial: Observable<ProductDetail[]>;
  myControlSemiFinishedMaterial = new UntypedFormControl();

  productDetailSearchPackaging: ProductDetail[] = [];
  filteredOptionsPackaging: Observable<ProductDetail[]>;
  myControlPackaging = new UntypedFormControl();

  productCosting: ProductCosting = new ProductCosting();
  costCart: ProductCosting[] = [];
  totalMaterialAmount: number = 0;
  convertedQty: number = 0;
  totalPackagingMaterialAmount: number = 0;

  totalRawMaterialAmount: number = 0;
  rawMaterialConvertedQty: number = 0;
  totalFinishedMaterialAmount: number = 0;
  finishedMaterialConvertedQty: number = 0;
  totalSemiFinishedMaterialAmount: number = 0;
  semiFinishedMaterialConvertedQty: number = 0;


  selectedUnit: string = '';
  selectedDurationType: string = '';

  noOfDaysAllowed: any;
  ActiveTab: number | string = 0;
  maxAllowDate: Date = new Date();

  //View Variable
  loginLocation: Location;
  companyName: string;
  parentLocationName: string;
  parentLocRefNo: string;
  locationList: Location[] = [];

  inventoryTypeList: InventoryType[] = [];
  matrixList: ProductMatrix[] = [];
  groupList: ProductGroup[] = [];
  subGroupList: ProductSubGroup[] = [];
  requestView: RequestView = new RequestView();

  optionalColumns: string[] = ['All', 'From Location', 'By User', 'Date', 'Price', 'Weight', 'Batch Size',
    'Cost Of Material Batch', 'Cost Of Packaging Batch', 'Production Loss', 'Overhead Loss', 'Total Material Qty', 'Total Packaging Qty', 'Converted Qty'];
  viewTableColumns: string[] = ['material', 'packaging', 'fromLocation', 'transactionNo', 'byUser', 'date', 'productName', 'price', 'weight', 'batchSize',
    'costOfMaterialBatch', 'costOfPackagingBatch', 'productionLoss', 'overheadLoss', 'overallCostBatch', 'totalMaterialQty', 'totalPackagingQty', 'convertedQty'];
  displayedColumnsActualSequence: string[] = ['material', 'packaging', 'fromLocation', 'transactionNo', 'byUser', 'date', 'productName', 'price', 'weight', 'batchSize',
    'costOfMaterialBatch', 'costOfPackagingBatch', 'productionLoss', 'overheadLoss', 'overallCostBatch', 'totalMaterialQty', 'totalPackagingQty', 'convertedQty'];
  selectedColumns: string[] = [];

  dataSourceView: MatTableDataSource<ProductCosting>;

  length: number;
  pageSize: number;
  pageEvent: PageEvent;
  viewDataList: ProductCosting[] = [];
  viewDataTempList: ProductCosting[] = [];

  allExpandMaterial: boolean = false;
  allExpandPackaging: boolean = false;
  allExpandProcess: boolean = false;

  exportSelectionDialogData: DialogDataModel = new DialogDataModel();
  excelFileName: string = "productcosting";
  subModuleName: string = "Costing";

  viewTotalMaterialQty: number = 0;

  filteredLocationList: Location[];
  filteredInventoryTypeList: InventoryType[] = [];
  filteredMatrixList: ProductMatrix[] = [];
  filteredProductGroupTypeList: ProductGroup[] = [];
  filteredProductSubGroupTypeList: ProductSubGroup[] = [];
  //Delete Variable

  matrixListForDelete: ProductMatrix[] = [];
  groupListForDelete: ProductGroup[] = [];
  subGroupListForDelete: ProductSubGroup[] = [];
  requestViewForDelete: RequestView = new RequestView();

  optionalColumnsForDelete: string[] = ['All', 'fromLocation', 'byUser', 'price', 'weight', 'batchSize',
    'costOfMaterialBatch', 'costOfPackagingBatch', 'date', 'productionLoss', 'totalMaterialQty', 'totalPackagingQty'];
  viewTableColumnsForDelete: string[] = ['fromLocation', 'transactionNo', 'byUser', 'productName', 'price', 'weight', 'batchSize',
    'costOfMaterialBatch', 'costOfPackagingBatch', 'date', 'productionLoss', 'totalMaterialQty', 'totalPackagingQty', 'delete'];
  actualSequenceForDelete: string[] = ['fromLocation', 'transactionNo', 'byUser', 'productName', 'price', 'weight', 'batchSize',
    'costOfMaterialBatch', 'costOfPackagingBatch', 'date', 'productionLoss', 'totalMaterialQty', 'totalPackagingQty', 'delete'];
  selectedColumnsForDelete: string[] = [];

  dataSourceForDelete: MatTableDataSource<ProductCosting>;

  lengthForDelete: number;
  pageSizeForDelete: number;
  pageEventForDelete: PageEvent;
  viewDataListForDelete: ProductCosting[] = [];
  viewDataTempListForDelete: ProductCosting[] = [];

  filteredDelInventoryTypeList: InventoryType[] = [];
  filteredDelMatrixTypeList: ProductMatrix[] = [];
  filteredDelGroupTypeList: ProductGroup[] = [];
  filteredDeSublGroupTypeList: ProductSubGroup[] = [];

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('paginatorForDelete') paginatorForDelete: MatPaginator;

  //Subscription
  private getAllUnitNamesSubscription: Subscription;
  private onSearchSubscription: Subscription;
  private getProductDetailSubscription: Subscription;
  private insertProductCostingSubscription: Subscription;
  private getLocByParentSubscription: Subscription;
  private getDataListSubscription: Subscription;
  private viewSubscription: Subscription;
  private cancelSubscription: Subscription;
  private getProductCostingSubscription: Subscription;

  private intervalSubscription: Subscription;

  constant: Constant = new Constant();

  //shortcurts

  saveShortcut = this.constant.saveShortcut;
  resetShortcut = this.constant.resetShortcut;
  exportShortcut = this.constant.exportShortcut;
  viewbtnShortcut = this.constant.viewbtnShortcut;
  tablefilterShortcut = this.constant.tablefilterShortcut;
  addShortcut = this.constant.addShortcut;
  @HostListener('document:keydown', ['$event'])
  handleGlobalKeydown(event: KeyboardEvent) {
    if (!event.altKey) return;
    const tabActions: Record<number, Record<string, () => void>> = {
      0: {
        s: () => this.onCostingSaveClick(),
        x: () => this.onExportClick(),
        v: () => this.onViewClickForDelete(true),
        i: () => this.onColumnSelectForDelete(this.selectedColumnsForDelete, true)
      }
    };
    const active = this.ActiveTab || 0;
    const actions = tabActions[active] || {};
    const key = event.key.toLowerCase();
    if (actions[key]) {
      event.preventDefault();
      event.stopPropagation();
      actions[key]();
    }
  }
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly apiUrl: APIFactoryEndPoints,
    private readonly productionService: ProductionService,
    private readonly mastercontainerService: MastercontainerService,
    public persistenceService: LocalStorageService,
    private readonly toastService: ToastService,
    public dialog: MatDialog,
    private readonly _liveAnnouncer: LiveAnnouncer
  ) {
    this.constant.setFormatFromStorage(persistenceService);
    this.loginLocation = JSON.parse(this.persistenceService.get('userDetail')).location;
    this.companyName = JSON.parse(this.persistenceService.get('userDetail')).company.companyName;
    this.parentLocationName = JSON.parse(this.persistenceService.get('userDetail')).parentLocationName;
    this.parentLocRefNo = JSON.parse(this.persistenceService.get('userDetail')).parentLocRefNo;

    this.dataSourceView = new MatTableDataSource(this.viewDataList);

    this.dataSourceForDelete = new MatTableDataSource(this.viewDataListForDelete);

    let isShowAll = this.persistenceService.get('OS') !== 'Android';

    if (this.persistenceService.get('product-costing-view-columns') && JSON.parse(this.persistenceService.get('product-costing-view-columns'))) {
      let columns = JSON.parse(this.persistenceService.get('product-costing-view-columns'));
      this.onColumnSelect(columns, true);
    } else {
      this.onColumnSelect(this.optionalColumns, isShowAll);
    }

    if (this.persistenceService.get('product-costing-delete-columns') && JSON.parse(this.persistenceService.get('product-costing-delete-columns'))) {
      let columns = JSON.parse(this.persistenceService.get('product-costing-delete-columns'));
      this.onColumnSelectForDelete(columns, true);
    } else {
      this.onColumnSelectForDelete(this.optionalColumnsForDelete, isShowAll);
    }
  }

  ngOnInit(): void {
    this.onCreateSetUp();
    this.onViewSetUp();
    this.onDeleteSetUp();
    this.getInventoryList();
    this.costCart[0] = new ProductCosting();
    this.costCart[1] = new ProductCosting();

    this.pageSize = this.constant.pageSize10;
    this.pageSizeForDelete = this.constant.pageSizeCommon;

    this.constant.enableGlobalFilter(this.dataSourceView);
    this.constant.enableGlobalFilter(this.dataSourceForDelete);
  }
  ngOnDestroy() {
    if (this.getAllUnitNamesSubscription !== undefined)
      this.getAllUnitNamesSubscription.unsubscribe();

    if (this.getProductDetailSubscription !== undefined)
      this.getProductDetailSubscription.unsubscribe();

    if (this.onSearchSubscription !== undefined)
      this.onSearchSubscription.unsubscribe();

    if (this.insertProductCostingSubscription !== undefined)
      this.insertProductCostingSubscription.unsubscribe();

    if (this.getLocByParentSubscription !== undefined)
      this.getLocByParentSubscription.unsubscribe();

    if (this.getDataListSubscription !== undefined)
      this.getDataListSubscription.unsubscribe();

    if (this.viewSubscription !== undefined)
      this.viewSubscription.unsubscribe();

    if (this.cancelSubscription !== undefined)
      this.cancelSubscription.unsubscribe();

    if (this.getProductCostingSubscription !== undefined)
      this.getProductCostingSubscription.unsubscribe();

  }
  getAllUnitNamesList() {
    this.getAllUnitNamesSubscription = this.productionService.getAllUnitNames(this.apiUrl.getAllUnitNames).subscribe((data: string[]) => {
      this.unitList = data;

      this.getChildLocByLoginLoc(this.loginLocation.refNo);
    })
  }
  onUnitSelect(unit: string) {
    this.selectedUnit = unit;
    this.myControlConvUnit.setValue(unit);
  }

  onCreateSetUp() {
    this.productionSetUpForm = this.formBuilder.group({
      productName: ['', Validators.required],
      price: ['', Validators.required],
      weight: ['', Validators.required],
      batchSize: ['', Validators.required],
      unit: ['', Validators.required],
      productionLoss: ['', Validators.required],
      overheadLoss: ['', Validators.required],

      // productDetail: new FormArray([this.createNewProductDetailChildDiv()]),
      rawMaterial: new UntypedFormArray([this.createNewProductDetailChildDiv()]),
      finishedMaterial: new UntypedFormArray([]),
      semiFinishedMaterial: new UntypedFormArray([]),
      packagingMaterial: new UntypedFormArray([this.createNewPackagingMaterialChildDiv()]),
    })
  }

  tabClicked(event: MatTabChangeEvent) {
    this.noOfDaysAllowed = this.persistenceService.get("noOfDaysAllowed")
    this.maxAllowDate = new Date();
    this.maxAllowDate.setDate(new Date().getDate() - this.noOfDaysAllowed + 1);
    if (this.noOfDaysAllowed == 0) {
      if (event.tab.textLabel != "ADD" && event.tab.textLabel != "VIEW") {
        this.ActiveTab = 0;
        this.toastService.clearAllToast();
        this.toastService.showErrorToast(this.constant.notAllowedToast)
      }
      else {
        this.ActiveTab = event.index;
      }
    }
  }

  onSearchProduct(productName: string) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    const source = this.constant.intervalTimeForSearch;
    this.intervalSubscription = source.subscribe(val => {
      this.intervalSubscription.unsubscribe();

      if (this.onSearchSubscription) {
        this.onSearchSubscription.unsubscribe();
      }
      this.onSearchSubscription = this.productionService.getProductSearch(this.apiUrl.productsByWord, productName).subscribe((data) => {
        this.productSearch = data;

        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filtering(value))
          );
      });
    });
  }

  _filtering(value: any): ProductDetail[] {
    if (typeof (value) === 'string') {
      let filterValue: string = value.toLowerCase();
      return this.productSearch.filter((option: ProductDetail) => option.product_Name.toLowerCase().includes(filterValue));
    }
  }
  onSearchProductSelect(product: ProductDetail) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    this.productCosting = new ProductCosting();
    this.rawMaterialFormArray.clear();
    this.semiFinishedMaterialFormArray.clear();
    this.finishedMaterialFormArray.clear();
    this.packagingMaterialFormArray.clear();
    this.costCart[0] = new ProductCosting();
    this.costCart[1] = new ProductCosting();
    this.calculateForRawMaterialFooter();
    this.calculateForFinishedMaterialFooter();
    this.calculateForSemiFinishedMaterialFooter();
    this.calculateForPackageFooter();
    this.selectedUnit = '';
    this.selectedDurationType = '';
    this.myControlConvUnit.reset();
    this.productCosting.productCode = product.product_Code;

    this.myControl.setValue(product.product_Name);

    this.productionSetUpForm.patchValue({
      productName: product.product_Name,
      // price: product.net_Sale_Price,
      price: product.sale_Price,
      unit: product.product_Unit,
      weight: null,
      batchSize: null,
      productionLoss: null,
      overheadLoss: null,
    })
    this.getProductCostingSubscription = this.productionService.getProductCostingByProductCode(this.apiUrl.getProductCostingByProductCode, product.product_Code).subscribe((data: ProductCosting) => {
      if (data) {
        this.setSavedProductCostingData(data);
      }
    })
  }

  setSavedProductCostingData(productCosting: ProductCosting) {
    this.productCosting.refNo = productCosting.refNo;
    this.productCosting.date = productCosting.date;
    this.productionSetUpForm.patchValue({
      // price: productCosting.rate,
      price: productCosting.productDetail.sale_Price,
      weight: productCosting.weight,
      batchSize: productCosting.batchSize,
      productionLoss: productCosting.productionLoss,
      overheadLoss: productCosting.overheadLoss,

      // rawMaterial: productCosting.productCostingRawMaterials,
      // finishedMaterial: productCosting.productCostingFinishedMaterials,
      // semiFinishedMaterial: productCosting.productCostingSemiFinishedMaterials,
      // packagingMaterial: productCosting.productCostingPackagings,
    })

    this.selectedUnit = productCosting.convertToUnit;
    this.myControlConvUnit.setValue(productCosting.convertToUnit);

    this.setMaterialsData(productCosting);
  }

  setMaterialsData(productCosting: ProductCosting) {

    if (productCosting.productCostingRawMaterials) {
      productCosting.productCostingRawMaterials.forEach(element => {
        let fg = this.createNewProductDetailChildDiv();
        fg.patchValue({
          productName: element.productDetail?.product_Name,
          productCode: element.productCode,
          unit: element.productDetail?.product_Unit,
          qty: element.qty,
          conversionFactor: element.conversionFactor,
          convertedQuantity: element.conversionFactor * element.qty,
          rate: element.rate,
          amount: element.rate * element.qty
        })
        this.rawMaterialFormArray.push(fg);
      })
    }

    if (productCosting.productCostingSemiFinishedMaterials) {
      productCosting.productCostingSemiFinishedMaterials.forEach(element => {
        let fg = this.createNewProductDetailChildDiv();
        fg.patchValue({
          productName: element.productDetail?.product_Name,
          productCode: element.productCode,
          unit: element.productDetail?.product_Unit,
          qty: element.qty,
          conversionFactor: element.conversionFactor,
          convertedQuantity: element.conversionFactor * element.qty,
          rate: element.rate,
          amount: element.rate * element.qty
        })
        this.semiFinishedMaterialFormArray.push(fg);
      })
    }

    if (productCosting.productCostingFinishedMaterials) {
      productCosting.productCostingFinishedMaterials.forEach(element => {
        let fg = this.createNewProductDetailChildDiv();
        fg.patchValue({
          productName: element.productDetail?.product_Name,
          productCode: element.productCode,
          unit: element.productDetail?.product_Unit,
          qty: element.qty,
          conversionFactor: element.conversionFactor,
          convertedQuantity: element.conversionFactor * element.qty,
          rate: element.rate,
          amount: element.rate * element.qty
        })
        this.finishedMaterialFormArray.push(fg);
      })
    }

    if (productCosting.productCostingPackagings) {
      productCosting.productCostingPackagings.forEach(element => {
        let fg = this.createNewPackagingMaterialChildDiv();
        fg.patchValue({
          productName: element.productDetail?.product_Name,
          productCode: element.productCode,
          unit: element.productDetail?.product_Unit,
          qty: element.qty,
          rate: element.rate,
          amount: element.rate * element.qty
        })
        this.packagingMaterialFormArray.push(fg);
      })
    }

    this.calculateForRawMaterialFooter();
    this.calculateForSemiFinishedMaterialFooter();
    this.calculateForFinishedMaterialFooter();
    this.calculateForPackageFooter();

  }



  createNewProductDetailChildDiv() {
    return this.formBuilder.group({
      productName: ['', Validators.required],
      productCode: ['', Validators.required],
      unit: ['', Validators.required],
      qty: ['', Validators.required],
      conversionFactor: ['', Validators.required],
      convertedQuantity: ['', Validators.required],
      rate: ['', Validators.required],
      amount: ['', Validators.required]
    })
  }

  //Raw Material
  get newRawMaterialForm() { return this.productionSetUpForm.controls; }
  get rawMaterialFormArray() {
    return this.newRawMaterialForm.rawMaterial as UntypedFormArray;
  }
  onRawMaterialAddRowClick() {
    this.rawMaterialFormArray.push(this.createNewProductDetailChildDiv());
  }
  onRawMaterialRemoveRowClick(index: number) {
    this.rawMaterialFormArray.removeAt(index);
    this.calculateForRawMaterialFooter();
  }
  onRawMaterialResetClick() {
    this.rawMaterialFormArray.clear();
    this.calculateForRawMaterialFooter();
  }

  //Finished goods
  get newFinishedMaterialForm() { return this.productionSetUpForm.controls; }
  get finishedMaterialFormArray() {
    return this.newFinishedMaterialForm.finishedMaterial as UntypedFormArray;
  }
  onFinishedMaterialAddRowClick() {
    this.finishedMaterialFormArray.push(this.createNewProductDetailChildDiv());
  }
  onFinishedMaterialRemoveRowClick(index: number) {
    this.finishedMaterialFormArray.removeAt(index);
    this.calculateForFinishedMaterialFooter();
  }
  onFinishedMaterialResetClick() {
    this.finishedMaterialFormArray.clear();
    this.calculateForFinishedMaterialFooter();
  }

  //Semi-Finished goods
  get newSemiFinishedMaterialForm() { return this.productionSetUpForm.controls; }
  get semiFinishedMaterialFormArray() {
    return this.newSemiFinishedMaterialForm.semiFinishedMaterial as UntypedFormArray;
  }
  onSemiFinishedMaterialAddRowClick() {
    this.semiFinishedMaterialFormArray.push(this.createNewProductDetailChildDiv());
  }
  onSemiFinishedMaterialRemoveRowClick(index: number) {
    this.semiFinishedMaterialFormArray.removeAt(index);
    this.calculateForSemiFinishedMaterialFooter();
  }
  onSemiFinishedMaterialResetClick() {
    this.semiFinishedMaterialFormArray.clear();
    this.calculateForSemiFinishedMaterialFooter();
  }


  createNewPackagingMaterialChildDiv() {
    return this.formBuilder.group({
      productName: ['', Validators.required],
      productCode: ['', Validators.required],
      unit: ['', Validators.required],
      qty: ['', Validators.required],
      rate: ['', Validators.required],
      amount: ['', Validators.required]
    })
  }
  get newPackagingForm() { return this.productionSetUpForm.controls; }
  get packagingMaterialFormArray() {
    return this.newPackagingForm.packagingMaterial as UntypedFormArray;
  }
  onPackagingMaterialAddRowClick() {
    this.packagingMaterialFormArray.push(this.createNewPackagingMaterialChildDiv());
  }
  onPackagingMaterialRemoveRowClick(index: number) {
    this.packagingMaterialFormArray.removeAt(index);
    this.calculateForPackageFooter();
  }
  onPackagingMaterialResetClick() {
    this.packagingMaterialFormArray.clear();
    this.calculateForPackageFooter();
  }


  //Raw Material
  onSearchRawMaterial(productName: string) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    const source = this.constant.intervalTimeForSearch;
    this.intervalSubscription = source.subscribe(val => {
      this.intervalSubscription.unsubscribe();

      if (this.onSearchSubscription) {
        this.onSearchSubscription.unsubscribe();
      }
      this.onSearchSubscription = this.productionService.getProducts(this.apiUrl.getProductsByInvIdAndName, this.constant.rawMaterialsInvId, productName).subscribe((data: ProductDetail[]) => {
        this.rawMaterialSearch = data;

        this.filteredOptionsRawMaterial = this.myControlRawMaterial.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterRawMaterial(value))
          );
      });
    });
  }
  _filterRawMaterial(value: any): ProductDetail[] {
    if (typeof (value) === 'string') {
      let filterValue: string = value.toLowerCase();
      return this.rawMaterialSearch.filter((option: ProductDetail) => option.product_Name.toLowerCase().includes(filterValue));
    }
  }
  onSearchRawMaterialSelect(product: ProductDetail, index: number) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    this.myControlRawMaterial.setValue(product.product_Name);
    this.getProductDetailSubscription = this.productionService.getProductByProductCode(this.apiUrl.getProductsWithLastPurchasePriceByProductCode, product.product_Code).subscribe((data: ProductDetail) => {
      this.setRawMaterialArrayValues(data, index);
    })
  }

  setRawMaterialArrayValues(product: ProductDetail, index: number) {
    this.rawMaterialFormArray.at(index).reset();
    let codes = this.rawMaterialFormArray.controls.map(e => e.get('productCode').value);
    if (codes.includes(product.product_Code)) {
      this.rawMaterialFormArray.at(index).reset();
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productAddedToast);
      return;
    }

    let fg = this.rawMaterialFormArray.at(index);
    fg.patchValue({
      productName: product.product_Name,
      productCode: product.product_Code,
      unit: product.product_Unit,
      qty: 1,
      conversionFactor: 1,
      convertedQuantity: 1,
      rate: product.lastPurchasePrice,
      amount: product.lastPurchasePrice
    })
    this.calculateForRawMaterialFooter();

    return this.rawMaterialFormArray;
  }

  //Finished Goods
  onSearchFinishedMaterial(productName: string) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    const source = this.constant.intervalTimeForSearch;
    this.intervalSubscription = source.subscribe(val => {
      this.intervalSubscription.unsubscribe();

      if (this.onSearchSubscription) {
        this.onSearchSubscription.unsubscribe();
      }
      this.onSearchSubscription = this.productionService.getProducts(this.apiUrl.getProductsByInvIdAndName, this.constant.finishedGoodsInvId, productName).subscribe((data: ProductDetail[]) => {
        this.finishedMaterialSearch = data;

        this.filteredOptionsFinishedMaterial = this.myControlFinishedMaterial.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterFinishedMaterial(value))
          );
      });
    });
  }
  _filterFinishedMaterial(value: any): ProductDetail[] {
    if (typeof (value) === 'string') {
      let filterValue: string = value.toLowerCase();
      return this.finishedMaterialSearch.filter((option: ProductDetail) => option.product_Name.toLowerCase().includes(filterValue));
    }
  }
  onSearchFinishedMaterialSelect(product: ProductDetail, index: number) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    this.myControlFinishedMaterial.setValue(product.product_Name);
    this.getProductDetailSubscription = this.productionService.getProductByProductCode(this.apiUrl.getProductsWithLastPurchasePriceByProductCode, product.product_Code).subscribe((data: ProductDetail) => {
      this.setFinishedMaterialArrayValues(data, index);
    })
  }

  setFinishedMaterialArrayValues(product: ProductDetail, index: number) {
    this.finishedMaterialFormArray.at(index).reset();
    let codes = this.finishedMaterialFormArray.controls.map(e => e.get('productCode').value);
    if (codes.includes(product.product_Code)) {
      this.finishedMaterialFormArray.at(index).reset();
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productAddedToast);
      return;
    }

    let fg = this.finishedMaterialFormArray.at(index);
    fg.patchValue({
      productName: product.product_Name,
      productCode: product.product_Code,
      unit: product.product_Unit,
      qty: 1,
      conversionFactor: 1,
      convertedQuantity: 1,
      rate: product.lastPurchasePrice,
      amount: product.lastPurchasePrice
    })
    this.calculateForFinishedMaterialFooter();

    return this.finishedMaterialFormArray;
  }

  //Semi-Finished Goods
  onSearchSemiFinishedMaterial(productName: string) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    const source = this.constant.intervalTimeForSearch;
    this.intervalSubscription = source.subscribe(val => {
      this.intervalSubscription.unsubscribe();

      if (this.onSearchSubscription) {
        this.onSearchSubscription.unsubscribe();
      }
      this.onSearchSubscription = this.productionService.getProducts(this.apiUrl.getProductsByInvIdAndName, this.constant.semiFinishedGoodsInvId, productName).subscribe((data: ProductDetail[]) => {
        this.semiFinishedMaterialSearch = data;

        this.filteredOptionsSemiFinishedMaterial = this.myControlSemiFinishedMaterial.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterSemiFinishedMaterial(value))
          );
      });
    });
  }
  _filterSemiFinishedMaterial(value: any): ProductDetail[] {
    if (typeof (value) === 'string') {
      let filterValue: string = value.toLowerCase();
      return this.semiFinishedMaterialSearch.filter((option: ProductDetail) => option.product_Name.toLowerCase().includes(filterValue));
    }
  }
  onSearchSemiFinishedMaterialSelect(product: ProductDetail, index: number) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    this.myControlSemiFinishedMaterial.setValue(product.product_Name);
    this.getProductDetailSubscription = this.productionService.getProductByProductCode(this.apiUrl.getProductsWithLastPurchasePriceByProductCode, product.product_Code).subscribe((data: ProductDetail) => {
      this.setSemiFinishedMaterialArrayValues(data, index);
    })
  }

  setSemiFinishedMaterialArrayValues(product: ProductDetail, index: number) {
    this.semiFinishedMaterialFormArray.at(index).reset();
    let codes = this.semiFinishedMaterialFormArray.controls.map(e => e.get('productCode').value);
    if (codes.includes(product.product_Code)) {
      this.semiFinishedMaterialFormArray.at(index).reset();
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productAddedToast);
      return;
    }

    let fg = this.semiFinishedMaterialFormArray.at(index);
    fg.patchValue({
      productName: product.product_Name,
      productCode: product.product_Code,
      unit: product.product_Unit,
      qty: 1,
      conversionFactor: 1,
      convertedQuantity: 1,
      rate: product.lastPurchasePrice,
      amount: product.lastPurchasePrice
    })
    this.calculateForSemiFinishedMaterialFooter();

    return this.semiFinishedMaterialFormArray;
  }

  onSearchProductPackaging(productName: string) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    const source = this.constant.intervalTimeForSearch;
    this.intervalSubscription = source.subscribe(val => {
      this.intervalSubscription.unsubscribe();

      if (this.onSearchSubscription) {
        this.onSearchSubscription.unsubscribe();
      }
      this.onSearchSubscription = this.productionService.getProducts(this.apiUrl.getProductsByInvIdAndName, this.constant.rawMaterialsInvId, productName).subscribe((data: ProductDetail[]) => {
        this.productDetailSearchPackaging = data;

        this.filteredOptionsPackaging = this.myControlPackaging.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterPackaging(value))
          );
      });
    });
  }
  _filterPackaging(value: any): ProductDetail[] {
    if (typeof (value) === 'string') {
      let filterValue: string = value.toLowerCase();
      return this.productDetailSearchPackaging.filter((option: ProductDetail) => option.product_Name.toLowerCase().includes(filterValue));
    }
  }
  onSearchProductSelectPackaging(product: ProductDetail, index: number) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    this.myControlPackaging.setValue(product.product_Name);
    this.getProductDetailSubscription = this.productionService.getProductByProductCode(this.apiUrl.getProductsWithLastPurchasePriceByProductCode, product.product_Code).subscribe((data: ProductDetail) => {
      this.setProductDetailPackagingArrayValues(data, index);
    })
  }

  setProductDetailPackagingArrayValues(product: ProductDetail, index: number) {
    this.packagingMaterialFormArray.at(index).reset();
    let codes = this.packagingMaterialFormArray.controls.map(e => e.get('productCode').value);
    if (codes.includes(product.product_Code)) {
      this.packagingMaterialFormArray.at(index).reset();
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productAddedToast);
      return;
    }

    let fg = this.packagingMaterialFormArray.at(index);
    fg.patchValue({
      productName: product.product_Name,
      productCode: product.product_Code,
      unit: product.product_Unit,
      qty: 1,
      // rate: product.net_Purchase_Price,
      // amount: product.net_Purchase_Price
      rate: product.lastPurchasePrice,
      amount: product.lastPurchasePrice
    })
    this.calculateForPackageFooter();

    return this.packagingMaterialFormArray;
  }

  //Raw Materials
  onRawMaterialQtyChange(event: any, index: number) {
    this.rawMaterialFormArray.at(index).get('amount').setValue(Number(Number(this.rawMaterialFormArray.at(index).get('qty').value * this.rawMaterialFormArray.at(index).get('rate').value).toFixed(2)));
    this.rawMaterialFormArray.at(index).get('convertedQuantity').setValue(this.rawMaterialFormArray.at(index).get('conversionFactor').value * this.rawMaterialFormArray.at(index).get('qty').value);
    this.calculateForRawMaterialFooter();
  }
  onRawMaterialQtyChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productQtyNotBeZeroToast);
      this.rawMaterialFormArray.at(index).get('qty').reset();
      this.rawMaterialFormArray.at(index).get('amount').reset();
      this.rawMaterialFormArray.at(index).get('convertedQuantity').reset();
    }
  }

  onRawMaterialConvsFactChange(event: any, index: number) {
    this.rawMaterialFormArray.at(index).get('convertedQuantity').setValue(this.rawMaterialFormArray.at(index).get('conversionFactor').value * this.rawMaterialFormArray.at(index).get('qty').value);
    this.calculateForRawMaterialFooter();
  }
  onRawMaterialConvsFactChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.conversionFactorToast);
      this.rawMaterialFormArray.at(index).get('conversionFactor').reset();
      this.rawMaterialFormArray.at(index).get('convertedQuantity').reset();
    }
  }
  onRawMaterialConvQtyChange(event: any, index: number) {
    this.rawMaterialFormArray.at(index).get('conversionFactor').setValue(this.rawMaterialFormArray.at(index).get('convertedQuantity').value / this.rawMaterialFormArray.at(index).get('qty').value);
    this.calculateForRawMaterialFooter();
  }
  onRawMaterialConvQtyChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.convertedQtyToast);
      this.rawMaterialFormArray.at(index).get('convertedQuantity').reset();
      this.rawMaterialFormArray.at(index).get('conversionFactor').reset();
    }
  }

  calculateForRawMaterialFooter() {
    this.totalRawMaterialAmount = 0;
    this.rawMaterialConvertedQty = 0;
    for (let i = 0; i < this.rawMaterialFormArray.length; i++) {
      this.totalRawMaterialAmount = Number((this.totalRawMaterialAmount + Number(this.rawMaterialFormArray.at(i).get('amount').value)).toFixed(2));
      this.rawMaterialConvertedQty = Number(this.rawMaterialConvertedQty + Number(this.rawMaterialFormArray.at(i).get('convertedQuantity').value));
    }

    this.totalMaterialAmount = Number((this.totalRawMaterialAmount + this.totalFinishedMaterialAmount + this.totalSemiFinishedMaterialAmount).toFixed(2));
    this.convertedQty = Number(this.rawMaterialConvertedQty + this.finishedMaterialConvertedQty + this.semiFinishedMaterialConvertedQty);
    this.calculateForCosting();
  }

  //Finished goods
  onFinishedMaterialQtyChange(event: any, index: number) {
    this.finishedMaterialFormArray.at(index).get('amount').setValue(Number(Number(this.finishedMaterialFormArray.at(index).get('qty').value * this.finishedMaterialFormArray.at(index).get('rate').value).toFixed(2)));
    this.finishedMaterialFormArray.at(index).get('convertedQuantity').setValue(this.finishedMaterialFormArray.at(index).get('conversionFactor').value * this.finishedMaterialFormArray.at(index).get('qty').value);
    this.calculateForFinishedMaterialFooter();
  }
  onFinishedMaterialQtyChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productQtyNotBeZeroToast);
      this.finishedMaterialFormArray.at(index).get('qty').reset();
      this.finishedMaterialFormArray.at(index).get('amount').reset();
      this.finishedMaterialFormArray.at(index).get('convertedQuantity').reset();
    }
  }

  onFinishedMaterialConvsFactChange(event: any, index: number) {
    this.finishedMaterialFormArray.at(index).get('convertedQuantity').setValue(this.finishedMaterialFormArray.at(index).get('conversionFactor').value * this.finishedMaterialFormArray.at(index).get('qty').value);
    this.calculateForFinishedMaterialFooter();
  }
  onFinishedMaterialConvsFactChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.conversionFactorToast);
      this.finishedMaterialFormArray.at(index).get('conversionFactor').reset();
      this.finishedMaterialFormArray.at(index).get('convertedQuantity').reset();
    }
  }

  onFinishedMaterialConvQtyChange(event: any, index: number) {
    this.finishedMaterialFormArray.at(index).get('conversionFactor').setValue(this.finishedMaterialFormArray.at(index).get('convertedQuantity').value / this.finishedMaterialFormArray.at(index).get('qty').value);
    this.calculateForFinishedMaterialFooter();
  }
  onFinishedMaterialConvQtyChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.convertedQtyToast);
      this.finishedMaterialFormArray.at(index).get('convertedQuantity').reset();
      this.finishedMaterialFormArray.at(index).get('conversionFactor').reset();
    }
  }

  calculateForFinishedMaterialFooter() {
    this.totalFinishedMaterialAmount = 0;
    this.finishedMaterialConvertedQty = 0;
    for (let i = 0; i < this.finishedMaterialFormArray.length; i++) {
      this.totalFinishedMaterialAmount = Number((this.totalFinishedMaterialAmount + Number(this.finishedMaterialFormArray.at(i).get('amount').value)).toFixed(2));
      this.finishedMaterialConvertedQty = Number(this.finishedMaterialConvertedQty + Number(this.finishedMaterialFormArray.at(i).get('convertedQuantity').value));
    }

    this.totalMaterialAmount = Number((this.totalRawMaterialAmount + this.totalFinishedMaterialAmount + this.totalSemiFinishedMaterialAmount).toFixed(2));
    this.convertedQty = Number(this.rawMaterialConvertedQty + this.finishedMaterialConvertedQty + this.semiFinishedMaterialConvertedQty);
    this.calculateForCosting();
  }

  //Semi-Finished goods
  onSemiFinishedMaterialQtyChange(event: any, index: number) {
    this.semiFinishedMaterialFormArray.at(index).get('amount').setValue(Number(Number(this.semiFinishedMaterialFormArray.at(index).get('qty').value * this.semiFinishedMaterialFormArray.at(index).get('rate').value).toFixed(2)));
    this.semiFinishedMaterialFormArray.at(index).get('convertedQuantity').setValue(this.semiFinishedMaterialFormArray.at(index).get('conversionFactor').value * this.semiFinishedMaterialFormArray.at(index).get('qty').value);
    this.calculateForSemiFinishedMaterialFooter();
  }
  onSemiFinishedMaterialQtyChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productQtyNotBeZeroToast);
      this.semiFinishedMaterialFormArray.at(index).get('qty').reset();
      this.semiFinishedMaterialFormArray.at(index).get('amount').reset();
      this.semiFinishedMaterialFormArray.at(index).get('convertedQuantity').reset();
    }
  }

  onSemiFinishedMaterialConvsFactChange(event: any, index: number) {
    this.semiFinishedMaterialFormArray.at(index).get('convertedQuantity').setValue(this.semiFinishedMaterialFormArray.at(index).get('conversionFactor').value * this.semiFinishedMaterialFormArray.at(index).get('qty').value);
    this.calculateForSemiFinishedMaterialFooter();
  }
  onSemiFinishedMaterialConvsFactChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.conversionFactorToast);
      this.semiFinishedMaterialFormArray.at(index).get('conversionFactor').reset();
      this.semiFinishedMaterialFormArray.at(index).get('convertedQuantity').reset();
    }
  }
  onSemiFinishedMaterialConvQtyChange(event: any, index: number) {
    this.semiFinishedMaterialFormArray.at(index).get('conversionFactor').setValue(this.semiFinishedMaterialFormArray.at(index).get('convertedQuantity').value / this.semiFinishedMaterialFormArray.at(index).get('qty').value);
    this.calculateForSemiFinishedMaterialFooter();
  }
  onSemiFinishedMaterialConvQtyChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.convertedQtyToast);
      this.semiFinishedMaterialFormArray.at(index).get('convertedQuantity').reset();
      this.semiFinishedMaterialFormArray.at(index).get('conversionFactor').reset();
    }
  }

  calculateForSemiFinishedMaterialFooter() {
    this.totalSemiFinishedMaterialAmount = 0;
    this.semiFinishedMaterialConvertedQty = 0;
    for (let i = 0; i < this.semiFinishedMaterialFormArray.length; i++) {
      this.totalSemiFinishedMaterialAmount = Number((this.totalSemiFinishedMaterialAmount + Number(this.semiFinishedMaterialFormArray.at(i).get('amount').value)).toFixed(2));
      this.semiFinishedMaterialConvertedQty = Number(this.semiFinishedMaterialConvertedQty + Number(this.semiFinishedMaterialFormArray.at(i).get('convertedQuantity').value));
    }

    this.totalMaterialAmount = Number((this.totalRawMaterialAmount + this.totalFinishedMaterialAmount + this.totalSemiFinishedMaterialAmount).toFixed(2));
    this.convertedQty = Number(this.rawMaterialConvertedQty + this.finishedMaterialConvertedQty + this.semiFinishedMaterialConvertedQty);
    this.calculateForCosting();
  }


  calculateForCosting() {

    this.costCart[0].costOfMaterialBatch = this.totalMaterialAmount;
    this.costCart[1].costOfMaterialBatch = Number((this.totalMaterialAmount / this.productionSetUpForm.get('batchSize').value).toFixed(2));
    this.costCart[0].costOfPackagingBatch = this.totalPackagingMaterialAmount;
    this.costCart[1].costOfPackagingBatch = Number((this.totalPackagingMaterialAmount / this.productionSetUpForm.get('batchSize').value).toFixed(2));
    this.costCart[0].productionLoss = Number(((this.productionSetUpForm.get('productionLoss').value / 100) * (this.totalMaterialAmount)).toFixed(2));
    this.costCart[1].productionLoss = Number(((this.productionSetUpForm.get('productionLoss').value / 100) * (this.totalMaterialAmount) / this.productionSetUpForm.get('batchSize').value).toFixed(2));
    this.costCart[0].overheadLoss = Number(((this.productionSetUpForm.get('overheadLoss').value / 100) * (this.totalMaterialAmount)).toFixed(2));
    this.costCart[1].overheadLoss = Number(((this.productionSetUpForm.get('overheadLoss').value / 100) * (this.totalMaterialAmount) / this.productionSetUpForm.get('batchSize').value).toFixed(2));

    this.costCart[0].overallCostBatch = Number((this.costCart[0].costOfMaterialBatch + this.costCart[0].costOfPackagingBatch + this.costCart[0].productionLoss + this.costCart[0].overheadLoss).toFixed(2));
    this.costCart[1].overallCostBatch = Number((this.costCart[1].costOfMaterialBatch + this.costCart[1].costOfPackagingBatch + this.costCart[1].productionLoss + this.costCart[1].overheadLoss).toFixed(2));

    this.costCart[0].overallWeightBatch = this.convertedQty;
    this.costCart[1].overallWeightBatch = Number(this.convertedQty / this.productionSetUpForm.get('batchSize').value);

  }

  onPackageQtyChange(event: any, index: number) {
    this.packagingMaterialFormArray.at(index).get('amount').setValue(Number(Number(this.packagingMaterialFormArray.at(index).get('qty').value * this.packagingMaterialFormArray.at(index).get('rate').value).toFixed(2)));
    this.calculateForPackageFooter();
  }
  onPackageQtyChangeFocusout(event: any, index: number) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.productQtyNotBeZeroToast);
      this.packagingMaterialFormArray.at(index).get('qty').reset();
      this.packagingMaterialFormArray.at(index).get('amount').reset();
    }
  }

  calculateForPackageFooter() {
    this.totalPackagingMaterialAmount = 0;
    for (let i = 0; i < this.packagingMaterialFormArray.length; i++) {
      this.totalPackagingMaterialAmount = Number((this.totalPackagingMaterialAmount + this.packagingMaterialFormArray.at(i).get('amount').value).toFixed(2));;
    }
    this.calculateForCosting();
  }


  onChangeData(event: any, field: string) {
    this.calculateForCosting();
  }

  onChangeDataFocusOut(event: any, field: string) {
    if (event.value <= 0) {
      event.value = null;
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(field + " must be greater than 0");
    }
    if (field == 'BatchSize') {
      this.productionSetUpForm.get('batchSize').setValue(event.value);
    }
    else if (field == 'Loss') {
      if (event.value > 100) {
        event.value = 100;
      }
      this.productionSetUpForm.get('productionLoss').setValue(event.value);
    }
    else if (field == 'Overhead') {
      if (event.value > 100) {
        event.value = 100;
      }
      this.productionSetUpForm.get('overheadLoss').setValue(event.value);
    }
    else if (field == 'Weight') {
      this.productionSetUpForm.get('weight').setValue(event.value);
    }
    this.calculateForCosting();
  }

  onCostingSaveClick() {
    if (this.productionSetUpForm.invalid) {
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }

    let headingMessage = this.constant.SaveData;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '23%',
      width: '346px',
      data: { heading: headingMessage }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.selectedUnit || this.selectedUnit == "") {
            this.toastService.clearAllToast();
            this.toastService.showErrorToast(this.constant.convertToUnitToast);
          }

          this.productCosting.costOfMaterialBatch = this.costCart[0].costOfMaterialBatch;
          this.productCosting.costOfPackagingBatch = this.costCart[0].costOfPackagingBatch;
          this.productCosting.overallCostBatch = this.costCart[0].overallCostBatch;
          this.productCosting.overallWeightBatch = this.costCart[0].overallWeightBatch;

          this.productCosting.productCostingRawMaterials = this.productionSetUpForm.get('rawMaterial').value;
          this.productCosting.productCostingFinishedMaterials = this.productionSetUpForm.get('finishedMaterial').value;
          this.productCosting.productCostingSemiFinishedMaterials = this.productionSetUpForm.get('semiFinishedMaterial').value;
          this.productCosting.productCostingPackagings = this.productionSetUpForm.get('packagingMaterial').value;

          this.productCosting.convertToUnit = this.selectedUnit;

          this.productCosting.rate = this.productionSetUpForm.get('price').value;
          this.productCosting.weight = this.productionSetUpForm.get('weight').value;
          this.productCosting.batchSize = Number(this.productionSetUpForm.get('batchSize').value);
          this.productCosting.productionLoss = Number(this.productionSetUpForm.get('productionLoss').value);
          this.productCosting.overheadLoss = Number(this.productionSetUpForm.get('overheadLoss').value);

          this.productCosting.fromLocationCode = this.loginLocation.refNo;
          this.insertProductCostingSubscription = this.productionService.insertProductCosting(this.apiUrl.insertProductCosting, this.productCosting).subscribe((data) => {
            this.productionSetUpForm.reset();
            this.rawMaterialFormArray.clear();
            this.finishedMaterialFormArray.clear();
            this.semiFinishedMaterialFormArray.clear();
            this.packagingMaterialFormArray.clear();
            this.productCosting = new ProductCosting();
            this.costCart[0] = new ProductCosting();
            this.costCart[1] = new ProductCosting();
            this.calculateForRawMaterialFooter();
            this.calculateForFinishedMaterialFooter();
            this.calculateForSemiFinishedMaterialFooter();
            this.calculateForPackageFooter();
            this.selectedUnit = '';
            this.selectedDurationType = '';
            this.myControlConvUnit.reset();
            this.toastService.showSuccessToast(this.constant.productionCostingToast);
          })
        }
      })
  }

  //View
  onViewSetUp() {
    this.viewSetUpForm = this.formBuilder.group({
      costingLocation: ['', Validators.required],
      inventoryType: ['', Validators.required],
      matrixCode: ['', Validators.required],
      groupCode: ['', Validators.required],
      subGroupCode: ['', Validators.required]
    })
  }

  getChildLocByLoginLoc(logInLocId: number) {
    this.getLocByParentSubscription = this.mastercontainerService.getChildLocationsByLocCode(this.apiUrl.getLocationsByParentCode, logInLocId).subscribe((data: Location[]) => {
      this.locationList = data;
      this.locationList.splice(0, 0, this.loginLocation);

      this.filteredLocationList = this.locationList;

      if (this.locationList.length == 1) {
        this.viewSetUpForm.get('costingLocation').setValue([this.loginLocation.refNo]);
        this.onLocationSelectView(false);
      }
    })
  }
  onLocationSelectView(event: boolean) {
    if (!event) {
      let locationCodes = this.viewSetUpForm.get('costingLocation').value;
      if (locationCodes.length == 0) {
        return;
      }
      this.requestView.locIds = locationCodes;
      this.requestView.pageNo = 0
      this.requestView.pageSize = this.constant.pageSize10;
    }
  }



  searchLocationFromList(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredLocationList = this.locationList.filter(s => s.locationName.toLocaleLowerCase().includes(searchValue));
  }


  getInventoryList() {
    this.getDataListSubscription = this.mastercontainerService.getAllInventory(this.apiUrl.viewInventoryType).subscribe((data: ProductMatrix[]) => {
      this.inventoryTypeList = data;
      this.filteredInventoryTypeList = data;
      this.filteredDelInventoryTypeList = data;
      this.getAllUnitNamesList();
    })
  }

  onViewInventorySelect(event: boolean) {
    this.viewSetUpForm.get('matrixCode').reset();
    this.viewSetUpForm.get('groupCode').reset();
    this.viewSetUpForm.get('subGroupCode').reset();
    this.totalSelecteViewMatrix = [];
    this.totalSelecteViewGroup = [];
    this.totalSelectViewSubGroup = [];
    if (!event) {
      let codes = this.viewSetUpForm.get('inventoryType').value;
      if (!codes || codes.length == 0) {
        return;
      }
      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.getDataListSubscription = this.mastercontainerService.getProductMatrixByInventoryType(this.apiUrl.getMatrixByInvCodesHavingCostingProducts, codes).subscribe((data: ProductMatrix[]) => {
        this.matrixList = data;
        this.filteredMatrixList = data;
      })
    }
  }
  searchInventoryType(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredInventoryTypeList = this.inventoryTypeList.filter(s => s.inventoryTypeName.toLowerCase().includes(searchValue));
  }


  onViewMatrixSelect(event: boolean) {
    this.viewSetUpForm.get('groupCode').reset();
    this.viewSetUpForm.get('subGroupCode').reset();
    this.totalSelecteViewGroup = [];
    this.totalSelectViewSubGroup = [];
    if (!event) {
      let codes = this.viewSetUpForm.get('matrixCode').value;
      if (!codes || codes.length == 0) {
        return;
      }
      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.getDataListSubscription = this.mastercontainerService.getProductGroupByProductMatrix(this.apiUrl.getGroupByMatrixCodesHavingCostingProducts, codes).subscribe((data: ProductGroup[]) => {
        this.groupList = data;
        this.filteredProductGroupTypeList = data;
      })
    }
  }
  searchMatrix(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredMatrixList = this.matrixList.filter(s => s.productMatrixName.toLowerCase().includes(searchValue));
  }

  onViewGroupSelect(event: boolean) {
    if (!event) {
      let codes = this.viewSetUpForm.get('groupCode').value;
      this.viewSetUpForm.get('subGroupCode').reset();
      this.totalSelectViewSubGroup = [];
      if (!codes || codes.length == 0) {
        return;
      }

      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.getDataListSubscription = this.mastercontainerService.getProductSubGroupsByProductGroup(this.apiUrl.getSubGroupByGroupCodeHavingCostingProducts, codes).subscribe((data: ProductSubGroup[]) => {
        this.subGroupList = data;
        this.filteredProductSubGroupTypeList = data;
      })
    }
  }

  searchProductGroup(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredProductGroupTypeList = this.groupList.filter(s => s[1].toLowerCase().includes(searchValue));
  }

  onViewSubGroupSelect(event: boolean) {
    if (!event) {
      let codes = this.viewSetUpForm.get('subGroupCode').value;
      if (!codes || codes.length == 0) {
        return;
      }
      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.requestView.subGroupCodes = codes;
      this.requestView.pageNo = 0
      this.requestView.pageSize = this.constant.pageSize10;
    }
  }



  searchSubGroupList(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredProductSubGroupTypeList = this.subGroupList.filter(s => s[1].toLowerCase().includes(searchValue));
  }

  onViewClick(showFirstPage: boolean) {
    if (this.viewSetUpForm.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    if (showFirstPage) {
      this.requestView.pageNo = 0;
      this.paginator.pageIndex = 0;
    }
    if (this.viewSubscription) {
      this.viewSubscription.unsubscribe();
    }
    this.viewSubscription = this.productionService.viewProductCosting(this.apiUrl.getProductCostingsByLocCode, this.requestView).subscribe((data: any) => {
      this.viewDataTempList = data.content;
      this.dataSourceView.data = data.content;
      this.length = data.totalElements;
      if (data.content.length == 0) {
        this.toastService.clearAllToast();
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
        this.viewTotalMaterialQty = 0;
      }
      if (data.content != null && data.content.length > 0) {
        this.viewTotalMaterialQty = data.content[0].viewTotalFooter.qty
      }
      let pos = this.requestView.pageNo * this.requestView.pageSize;
      this.viewDataTempList.forEach((element: any) => {
        this.viewDataList.splice(pos, 1, element);
        pos++;
      })
    })
  }
  handleViewPage(event?: PageEvent): any {
    this.pageEvent = event;
    this.requestView.pageNo = this.pageEvent.pageIndex;
    this.requestView.pageSize = this.pageEvent.pageSize;
    this.viewDataTempList = [];
    this.onViewClick(false);
  }

  searchView(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceView.filter = filterValue.trim().toLowerCase();
  }

  onExportClick() {
    this.exportSelectionDialogData.requestView = this.requestView;
    this.exportSelectionDialogData.excelFileName = this.excelFileName;
    this.exportSelectionDialogData.subModuleName = this.subModuleName;
    this.dialog.open(SelectPreferenceComponent, {

      data: this.exportSelectionDialogData
    });
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  @ViewChild(MatSort, { static: false })
  set sort(value: MatSort) {
    this.dataSourceView.sort = value;
    this.dataSourceView.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'fromLocation': return item.fromLocation.locationName;
        case 'transactionNo': return item.refNo;
        case 'byUser': return item.user?.user_Name;
        case 'date': return item.date;
        case 'productName': return item.productDetail?.product_Name;
        case 'price': return item.productDetail.sale_Price;
        case 'weight': return item.weight;
        case 'batchSize': return item.batchSize;
        case 'costOfMaterialBatch': return item.costOfMaterialBatch;
        case 'costOfPackagingBatch': return item.costOfPackagingBatch;
        case 'productionLoss': return item.productionLoss;
        case 'overheadLoss': return item.overheadLoss;
        case 'overallCostBatch': return item.overallCostBatch;
        case 'totalMaterialQty': return item.totalMaterialQty;
        case 'totalPackagingQty': return item.totalPackagingQty;
        case 'convertedQty': return item.overallWeightBatch;
        default: return item[property];
      }
    }
  }
  //Delete
  onDeleteSetUp() {
    this.deleteSetUpForm = this.formBuilder.group({
      inventoryType: ['', Validators.required],
      matrixCode: ['', Validators.required],
      groupCode: ['', Validators.required],
      subGroupCode: ['', Validators.required]
    })
  }

  onInventorySelectForDelete(event: boolean) {
    this.deleteSetUpForm.get('matrixCode').reset();
    this.deleteSetUpForm.get('groupCode').reset();
    this.deleteSetUpForm.get('subGroupCode').reset();
    this.totalSelectedMatrixForDelt = [];
    this.totalSelecteGroupForDelt = [];
    this.totalSelecteSubGroupForDelt = [];
    if (!event) {
      let codes = this.deleteSetUpForm.get('inventoryType').value;
      if (!codes || codes.length == 0) {
        return;
      }
      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.getDataListSubscription = this.mastercontainerService.getProductMatrixByInventoryType(this.apiUrl.getMatrixByInvCodesHavingCostingProducts, codes).subscribe((data: ProductMatrix[]) => {
        this.matrixListForDelete = data;
        this.filteredDelMatrixTypeList = data;
      })
    }
  }



  searchDelInventory(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredDelInventoryTypeList = this.inventoryTypeList.filter(s => s.inventoryTypeName.toLowerCase().includes(searchValue));
  }

  onMatrixSelectForDelete(event: boolean) {
    this.deleteSetUpForm.get('groupCode').reset();
    this.deleteSetUpForm.get('subGroupCode').reset();
    this.totalSelecteGroupForDelt = [];
    this.totalSelecteSubGroupForDelt = [];
    if (!event) {
      let codes = this.deleteSetUpForm.get('matrixCode').value;
      if (!codes || codes.length == 0) {
        return;
      }
      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.getDataListSubscription = this.mastercontainerService.getProductGroupByProductMatrix(this.apiUrl.getGroupByMatrixCodesHavingCostingProducts, codes).subscribe((data: ProductGroup[]) => {
        this.groupListForDelete = data;
        this.filteredDelGroupTypeList = data;
      })
    }
  }



  searchDelMatrix(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredDelMatrixTypeList = this.matrixListForDelete.filter(s => s.productMatrixName.toLowerCase().includes(searchValue));
  }

  onGroupSelectForDelete(event: boolean) {
    if (!event) {
      let codes = this.deleteSetUpForm.get('groupCode').value;
      this.deleteSetUpForm.get('subGroupCode').reset();
      this.totalSelecteSubGroupForDelt = [];
      if (!codes || codes.length == 0) {
        return;
      }
      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.getDataListSubscription = this.mastercontainerService.getProductSubGroupsByProductGroup(this.apiUrl.getSubGroupByGroupCodeHavingCostingProducts, codes).subscribe((data: ProductSubGroup[]) => {
        this.subGroupListForDelete = data;
        this.filteredDeSublGroupTypeList = data;
      })
    }
  }



  searchDelGroup(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredDelGroupTypeList = this.groupListForDelete.filter(s => s[1].toLowerCase().includes(searchValue));
  }

  onSubGroupSelectForDelete(event: boolean) {
    if (!event) {
      let codes = this.deleteSetUpForm.get('subGroupCode').value;
      if (!codes || codes.length == 0) {
        return;
      }
      codes = this.constant.removeZeroAndNullFromArray(codes);

      this.requestViewForDelete.locIds = [];
      this.requestViewForDelete.locIds.push(this.loginLocation.refNo);
      this.requestViewForDelete.subGroupCodes = codes;
      this.requestViewForDelete.pageNo = 0
      this.requestViewForDelete.pageSize = this.constant.pageSizeCommon;
    }
  }
  searchDelSubGroup(event: any) {
    let searchValue: string = event.toLowerCase().trim();
    this.filteredDeSublGroupTypeList = this.subGroupListForDelete.filter(s => s[1].toLowerCase().includes(searchValue));
  }

  onViewClickForDelete(showFirstPage: boolean) {
    if (this.deleteSetUpForm.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    if (showFirstPage) {
      this.requestViewForDelete.pageNo = 0;
      this.paginatorForDelete.pageIndex = 0;
    }
    this.viewSubscription = this.productionService.viewProductCosting(this.apiUrl.getProductCostingsByLocCode, this.requestViewForDelete).subscribe((data: any) => {
      this.viewDataTempListForDelete = data.content;
      this.dataSourceForDelete.data = data.content;
      this.lengthForDelete = data.totalElements;
      if (data.content.length == 0) {
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
      }
      let pos = this.requestViewForDelete.pageNo * this.requestViewForDelete.pageSize;
      this.viewDataTempListForDelete.forEach((element: any) => {
        this.viewDataListForDelete.splice(pos, 1, element);
        pos++;
      })
    })
  }
  handleViewPageForDelete(event?: PageEvent): any {
    this.pageEventForDelete = event;
    this.requestViewForDelete.pageNo = this.pageEventForDelete.pageIndex;
    this.requestViewForDelete.pageSize = this.pageEventForDelete.pageSize;
    this.viewDataTempListForDelete = [];
    this.onViewClickForDelete(false);
  }

  searchDelete(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceForDelete.filter = filterValue.trim().toLowerCase();
  }

  onDeleteRowClick(costingNo: string) {
    let headingMessage = this.constant.cancelHeadingMessage;
    let subMessage = "ProductCosting will be Cancelled";

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '23%',
      width: '346px',
      data: { heading: headingMessage, message: subMessage }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cancelSubscription = this.productionService.cancelProductCosting(this.apiUrl.cancelProductCostingByCostingNo, costingNo).subscribe({
          next: (data: any) => {
            this.toastService.showSuccessToast("ProductCosting has been cancelled For Costing No: " + costingNo);
            this.onViewClickForDelete(false);
          },
          error: (error: HttpErrorResponse) => {
            this.onViewClickForDelete(false);
          }
        });
      }
    });
  }

  onColumnSelect(columnNames: string[], isShowAll: boolean) {
    let defaultColumns = ['material', 'packaging', 'transactionNo', 'productName', 'overallCostBatch'];
    if (columnNames.length < this.optionalColumns.length &&
      columnNames.includes('All') && this.selectedColumns.includes('All')) {
      let index = columnNames.findIndex(e => e == 'All');
      columnNames.splice(index, 1);
    } else if (!columnNames.includes('All') && this.selectedColumns.includes('All')) {
      columnNames = [];
    }

    if (columnNames.includes('All')) {
      columnNames = this.optionalColumns;
    }

    if (isShowAll) {
      let columns = [];
      columnNames.forEach(temp => {
        if (temp != 'All') {
          temp = temp.replaceAll(' ', '');
          temp = temp[0].toLocaleLowerCase() + temp.substring(1);
          columns.push(temp);
        }
      });

      this.viewTableColumns = [];
      this.displayedColumnsActualSequence.forEach(temp => {
        if (columns.includes(temp) || defaultColumns.includes(temp)) {
          this.viewTableColumns.push(temp)
        }
      });
      this.selectedColumns = columnNames;
      this.persistenceService.set('product-costing-view-columns', JSON.stringify(columnNames));
    } else {
      this.viewTableColumns = defaultColumns;
      this.selectedColumns = [];
    }
  }

  onColumnSelectForDelete(columnNames: string[], isShowAll: boolean) {
    let defaultColumns = ['transactionNo', 'productName', 'delete'];
    if (columnNames.length < this.optionalColumnsForDelete.length &&
      columnNames.includes('All') && this.selectedColumnsForDelete.includes('All')) {
      let index = columnNames.findIndex(e => e == 'All');
      columnNames.splice(index, 1);
    } else if (!columnNames.includes('All') && this.selectedColumnsForDelete.includes('All')) {
      columnNames = [];
    }

    if (columnNames.includes('All')) {
      columnNames = this.optionalColumnsForDelete;
    }

    if (isShowAll) {
      let columns = [];
      columnNames.forEach(temp => {
        if (temp != 'All') {
          temp = temp.replaceAll(' ', '');
          temp = temp[0].toLocaleLowerCase() + temp.substring(1);
          columns.push(temp);
        }
      });

      this.viewTableColumnsForDelete = [];
      this.actualSequenceForDelete.forEach(temp => {
        if (columns.includes(temp) || defaultColumns.includes(temp)) {
          this.viewTableColumnsForDelete.push(temp)
        }
      });
      this.selectedColumnsForDelete = columnNames;
      this.persistenceService.set('product-costing-delete-columns', JSON.stringify(columnNames));
    } else {
      this.viewTableColumnsForDelete = defaultColumns;
      this.selectedColumnsForDelete = [];
    }
  }
  totalSelectedLocIds = [];
  onLocationSelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredLocationList.map(e => e.refNo));
    this.totalSelectedLocIds.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.viewSetUpForm.get('costingLocation').setValue(locIds);
    this.totalSelectedLocIds = locIds;
  }

  allLocationSelect() {
    let seletedData = [];
    let existingData = this.viewSetUpForm.get('costingLocation').value;
    let isAlreadyAllSelected = this.filteredLocationList.every(e => existingData.includes(e.refNo));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredLocationList.map(e => e.refNo);
    }
    this.onLocationSelectionChange(seletedData);
  }

  totalSelecteViewInventory = [];
  onViewInventorySelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredInventoryTypeList.map(e => e.refNo));
    this.totalSelecteViewInventory.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.viewSetUpForm.get('inventoryType').setValue(locIds);
    this.totalSelecteViewInventory = locIds;
  }

  allInventoryTypeSelect() {
    let seletedData = [];
    let existingData = this.viewSetUpForm.get('inventoryType').value;
    let isAlreadyAllSelected = this.filteredInventoryTypeList.every(e => existingData.includes(e.refNo));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredInventoryTypeList.map(e => e.refNo);
    }
    this.onViewInventorySelectionChange(seletedData);
  }
  totalSelecteViewMatrix = [];
  onViewMatrixSelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredMatrixList.map(e => e.refNo));
    this.totalSelecteViewMatrix.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.viewSetUpForm.get('matrixCode').setValue(locIds);
    this.totalSelecteViewMatrix = locIds;
  }

  allMatrixSelect() {
    let seletedData = [];
    let existingData = this.viewSetUpForm.get('matrixCode').value;
    let isAlreadyAllSelected = this.filteredMatrixList.every(e => existingData.includes(e.refNo));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredMatrixList.map(e => e.refNo);
    }
    this.onViewMatrixSelectionChange(seletedData);
  }

  totalSelecteViewGroup = [];
  onViewGroupSelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredProductGroupTypeList.map(e => e[0]));
    this.totalSelecteViewGroup.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.viewSetUpForm.get('groupCode').setValue(locIds);
    this.totalSelecteViewGroup = locIds;
  }

  allProductGroupSelect() {
    let seletedData = [];
    let existingData = this.viewSetUpForm.get('groupCode').value;
    let isAlreadyAllSelected = this.filteredProductGroupTypeList.every(e => existingData.includes(e[0]));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredProductGroupTypeList.map(e => e[0]);
    }
    this.onViewGroupSelectionChange(seletedData);
  }

  totalSelectViewSubGroup = [];
  onViewSubGroupSelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredProductSubGroupTypeList.map(e => e[0]));
    this.totalSelectViewSubGroup.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.viewSetUpForm.get('subGroupCode').setValue(locIds);
    this.totalSelectViewSubGroup = locIds;
  }

  allProductSubGroupSelect() {
    let seletedData = [];
    let existingData = this.viewSetUpForm.get('subGroupCode').value;
    let isAlreadyAllSelected = this.filteredProductSubGroupTypeList.every(e => existingData.includes(e[0]));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredProductSubGroupTypeList.map(e => e[0]);
    }
    this.onViewSubGroupSelectionChange(seletedData);
  }

  totalSelectInventoryForDelt = [];
  onDeltInventorySelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredDelInventoryTypeList.map(e => e.refNo));
    this.totalSelectInventoryForDelt.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.deleteSetUpForm.get('inventoryType').setValue(locIds);
    this.totalSelectInventoryForDelt = locIds;
  }

  allInventoryDelTypeSelect() {
    let seletedData = [];
    let existingData = this.deleteSetUpForm.get('inventoryType').value;
    let isAlreadyAllSelected = this.filteredDelInventoryTypeList.every(e => existingData.includes(e.refNo));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredDelInventoryTypeList.map(e => e.refNo);
    }
    this.onDeltInventorySelectionChange(seletedData);
  }

  totalSelectedMatrixForDelt = [];
  onDeltMatrixSelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredDelMatrixTypeList.map(e => e.refNo));
    this.totalSelectedMatrixForDelt.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.deleteSetUpForm.get('matrixCode').setValue(locIds);
    this.totalSelectedMatrixForDelt = locIds;
  }

  allMatrixDelTypeSelect() {
    let seletedData = [];
    let existingData = this.deleteSetUpForm.get('matrixCode').value;
    let isAlreadyAllSelected = this.filteredDelMatrixTypeList.every(e => existingData.includes(e.refNo));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredDelMatrixTypeList.map(e => e.refNo);
    }
    this.onDeltMatrixSelectionChange(seletedData);
  }

  totalSelecteGroupForDelt = [];
  onDeltGroupSelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredDelGroupTypeList.map(e => e[0]));
    this.totalSelecteGroupForDelt.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.deleteSetUpForm.get('groupCode').setValue(locIds);
    this.totalSelecteGroupForDelt = locIds;
  }

  allgroupDelTypeSelect() {
    let seletedData = [];
    let existingData = this.deleteSetUpForm.get('groupCode').value;
    let isAlreadyAllSelected = this.filteredDelGroupTypeList.every(e => existingData.includes(e[0]));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredDelGroupTypeList.map(e => e[0]);
    }
    this.onDeltGroupSelectionChange(seletedData);
  }

  totalSelecteSubGroupForDelt = [];
  onDeltSubGroupSelectionChange(locIds: number[]) {
    let filteredIds = new Set(this.filteredDeSublGroupTypeList.map(e => e[0]));
    this.totalSelecteSubGroupForDelt.forEach(e => {
      if (e && e != '0' && !filteredIds.has(e)) {
        locIds.push(e);
      }
    })
    this.deleteSetUpForm.get('subGroupCode').setValue(locIds);
    this.totalSelecteSubGroupForDelt = locIds;
  }

  allSubGroupDelTypeSelect() {
    let seletedData = [];
    let existingData = this.deleteSetUpForm.get('subGroupCode').value;
    let isAlreadyAllSelected = this.filteredDeSublGroupTypeList.every(e => existingData.includes(e[0]));
    if (!isAlreadyAllSelected) {
      seletedData = this.filteredDeSublGroupTypeList.map(e => e[0]);
    }
    this.onDeltSubGroupSelectionChange(seletedData);
  }


}